import React from 'react'
import { isEmpty } from 'lodash'
import useFetchList from '../../../../../../elements/Hooks/useFetchList'
import CustomTable from '../../../../../../elements/Table/CustomTable'
import SalesContractsApi from '../../../../../../api/Sales/SalesContracts'
import MoneyCell from '../../../../../../elements/Table/Cells/MoneyCell'
import DateTimeCell from '../../../../../../elements/Table/Cells/DateTimeCell'
import SumFooter from '../../../../../../elements/Table/Footers/SumFooter'

const api = new SalesContractsApi()

export function AccountBalanceLinesCont(props) {
  const { contract } = props
  const { list, fetching, fetch } = useFetchList(
    () => api.accountBalanceLines(contract._id),
    [contract._id],
    isEmpty(contract._id)
  )
  return (
    <AccountBalanceLines
      {...{
        list,
        fetching,
        fetch,
      }}
    />
  )
}

AccountBalanceLinesCont.propTypes = {}
AccountBalanceLinesCont.defaultProps = { contract: {} }

export default AccountBalanceLinesCont

function AccountBalanceLines(props) {
  const { list, fetching, fetch } = props
  const columns = [
    {
      Header: 'ID',
      accessor: '_key',
    },
    {
      Header: 'Type',
      accessor: 'type',
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      Cell: MoneyCell,
      Footer: SumFooter,
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: DateTimeCell,
    },
    {
      Header: 'Document Type',
      accessor: 'docType',
    },
    {
      Header: 'Document ID',
      accessor: 'doc._id',
    },
    {
      Header: 'Operation',
      accessor: 'operation',
    },
    {
      Header: 'Owner',
      accessor: 'owner.fn',
    },
  ]
  return (
    <CustomTable
      isFilterable={true}
      defaultPageSize={20}
      fetch={fetch}
      fetching={fetching}
      data={list}
      columns={columns}
    />
  )
}
